import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

/** §19.2 — Boş durum: ikon + açıklayıcı Türkçe cümle + birincil aksiyon. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      <div className="rounded-full bg-accent-soft p-3">
        <Icon className="size-6 text-accent" aria-hidden="true" />
      </div>
      <div className="space-y-1">
        <p className="text-base font-medium text-fg">{title}</p>
        <p className="max-w-md text-sm text-fg-muted">{description}</p>
      </div>
      {action}
    </div>
  );
}
